import React, { Component } from 'react';
import ConfigureItem from './ConfigureItem';
import '../styles/adminPage.css';
import api from '../api';

class KalConfigure extends Component {

    state = {
        items: []
    }

    async componentDidMount() {
        try {
            const items = await api({
                url: `/api/${this.props.type}`,
            }) || []
            this.setState({ items })
        } catch (error) {

        }

    }


    add = () => {
        const { items } = this.state;
        items.push({});
        this.setState({ items });
    }
    remove = (i) => {
        const items = [...this.state.items]
        items.splice(i, 1)
        this.setState({ items })
    }

    onChange = (item, i) => {
        const { items } = this.state;
        items[i] = item
        this.setState({ items })
    }

    submit = async (e) => {
        e.preventDefault()
        const isValid = this.formRef.checkValidity()
        if (isValid) {
            this.setState({ loading: true })
            try {
                await api({
                    url: `/api/${this.props.type}`,
                    method: 'post',
                    body: {
                        data: JSON.stringify(this.state.items)
                    }
                })
                alert('Save successfully');
            } catch (error) {
                alert('Some error happened')
            } finally {
                this.setState({ loading: false })
            }

        }
    }

    render() {
        const { items = [], loading } = this.state;
        const { columns = [], } = this.props;
        return (
            <form ref={e => this.formRef = e} onSubmit={this.submit}>
                <div className='flexLayout line-item'>
                    {
                        columns.map(c => (<div key={c.name} className={`count title ${c.className}`}>{c.label}</div>))
                    }
                    <span style={{ width: 50 }}></span>
                </div>
                {
                    items.map((i, k) => <ConfigureItem keys={columns} key={`item_${k}`} item={i} index={k} onChange={this.onChange} onDelete={this.remove} />)
                }
                <div className='flexBetween' style={{ marginTop: 20 }}>
                    <div className='add-more-btn' onClick={this.add}>Add element</div>
                    <button type="submit" style={{ width: 200, fontSize: '2rem' }} className="btn btn-primary">{loading ? 'Loading' : 'Save'}</button>
                </div>
            </form>
        );
    }
}

export default KalConfigure;